import { render, staticRenderFns } from "./InvestorConfirmation.vue?vue&type=template&id=179b6514&"
import script from "./InvestorConfirmation.vue?vue&type=script&lang=js&"
export * from "./InvestorConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports